"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketNamespace = void 0;
// socket.io addresses a namespace by this exact slash-prefixed name.
var WebSocketNamespace;
(function (WebSocketNamespace) {
    WebSocketNamespace["Notary"] = "/notary";
    WebSocketNamespace["None"] = "/";
    WebSocketNamespace["Advisor"] = "/advisor";
    WebSocketNamespace["Origination"] = "/origination";
    WebSocketNamespace["PartnerDashboard"] = "/partnerDashboard";
})(WebSocketNamespace || (exports.WebSocketNamespace = WebSocketNamespace = {}));
